import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7194a2d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = { class: "activity-header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "activity-name" }
const _hoisted_5 = {
  key: 1,
  class: "activity-rating"
}
const _hoisted_6 = { class: "activity-content" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Serviços Executados", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "item"
}
const _hoisted_13 = { class: "text" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "SLA de Aceite", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_16 = { class: "item" }
const _hoisted_17 = { class: "text" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "SLA de Início", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_20 = { class: "item" }
const _hoisted_21 = { class: "text" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "SLA de Finalização", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))

import { AtomStar, MedalNumber } from '../atoms';
import AtomProgressBar from '../atoms/AtomProgressBar.vue';
import { withDefaults } from 'vue';

interface IProps {
    index?: number;
    img?: string;
    name?: string;
    rating?: number;
    servicesFinished: number;
    toAccept?: number;
    toStart: number;
    toEnd: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeDataCard',
  props: {
    index: { default: 0 },
    img: { default: '' },
    name: { default: '' },
    rating: { default: undefined },
    servicesFinished: { default: 0 },
    toAccept: { default: undefined },
    toStart: { default: 0 },
    toEnd: { default: 0 }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "medal", {
      index: props.index
    }, () => [
      _createVNode(_unref(MedalNumber), {
        number: props.index + 1,
        class: "icon"
      }, null, 8, ["number"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "activity-img",
        src: props.img,
        alt: "img"
      }, null, 8, _hoisted_3),
      _createElementVNode("span", _hoisted_4, _toDisplayString(props.name), 1),
      (props.rating !== undefined)
        ? (_openBlock(), _createBlock(_unref(AtomStar), {
            key: 0,
            rating: props.rating
          }, null, 8, ["rating"]))
        : _createCommentVNode("", true),
      (props.rating !== undefined)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(props.rating.toFixed(2).replace('.', ',')) + " estrelas ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(props.servicesFinished), 1)
        ]),
        _hoisted_11
      ]),
      (props.toAccept !== undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(AtomProgressBar, {
                value: (props.toAccept * 100)
              }, null, 8, ["value"])
            ]),
            _hoisted_15
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(AtomProgressBar, {
            value: (props.toStart * 100)
          }, null, 8, ["value"])
        ]),
        _hoisted_19
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(AtomProgressBar, {
            value: (props.toEnd * 100)
          }, null, 8, ["value"])
        ]),
        _hoisted_23
      ])
    ])
  ]))
}
}

})